import React from 'react'
import cx from 'classnames'

import { Image, ImageProps } from 'components/_new/ui'

import s from './ProductImage.scss'

import emptyImage from './images/empty.svg'


type ProductImageProps = {
  className?: string
  src: string
  resizeBy: ImageProps['resizeBy']
  height?: number // should be used for Lambda resize on Desktop and Tablets
  aspectRatio?: number // should be used for Zina resize on Mobile
  imagePercentage?: 80 | 100 // what height of the container in percentage image should occupy
  alt: string
  dataTestId?: string
}

const ProductImage: React.FunctionComponent<ProductImageProps> = (props) => {
  const { className, height = 100, aspectRatio = 1, src, resizeBy, alt, imagePercentage = 80, dataTestId } = props

  return (
    <div className={cx(s.container, className)}>
      <Image
        className={cx(s.image, s[`image-${imagePercentage}`])}
        src={src || emptyImage}
        x2
        x3
        h={height}
        resizeBy={resizeBy}
        alt={alt}
        dataTestId={dataTestId}
      />
      <div
        className={s.placeholder}
        style={{ paddingBottom: `${Math.round(100 / aspectRatio)}%` }}
      />
    </div>
  )
}


export default ProductImage
